Vue.component('ack-curo-resins-product-logo', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curo-resins-product-logo',
	mounted() {
		if (this.menuItems?.length > 0 && !this.activeItem) {
			this.menuItemClick(this.menuItems[0]);
		}
	},
	props: {
		menuItems: {
			// :product-info
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: false,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		activeItem: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...Vuex.mapGetters('resins', ['activeItem']),
		itemClass() {
			let currentPage = window.location.href;
			return this.menuItems.length === 3 && !currentPage.includes('pages/pac-dent')
				? 'justify-content-center'
				: 'justify-content-start';
		},
	},
	data() {
		return {};
	},
	methods: {
		...Vuex.mapActions('resins', ['menuItemClick']),
	},
	beforeDestroy() {},
	watch: {
		prop1: {
			handler() {},
			deep: false,
		},
	},
});
